// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"51f8d827","453":"f12fb91e","667":"eaa06ad2"}[chunkId] + ".chunk.js";
};